import { useEffect } from 'react';

/**
 * SEO Head Component - Manages meta tags and structured data
 */
export const SEOHead = ({ 
  title, 
  description, 
  keywords,
  author,
  publishedTime,
  modifiedTime,
  article = false,
  image,
  url,
  type = 'website',
  schema 
}) => {
  useEffect(() => {
    // Set document title
    document.title = title ? `${title} | RADIUS CONSULTING` : 'RADIUS CONSULTING - Marketing & Branding Consultancy';

    // Update or create meta tags
    const updateMetaTag = (property, content, isName = false) => {
      if (!content) return;
      
      const attribute = isName ? 'name' : 'property';
      let tag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, property);
        document.head.appendChild(tag);
      }
      
      tag.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description, true);
    updateMetaTag('keywords', keywords, true);
    updateMetaTag('author', author, true);

    // Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:type', article ? 'article' : type);
    updateMetaTag('og:url', url || window.location.href);
    updateMetaTag('og:image', image);
    updateMetaTag('og:site_name', 'RADIUS CONSULTING');

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', image, true);

    // Article-specific tags
    if (article) {
      updateMetaTag('article:published_time', publishedTime);
      updateMetaTag('article:modified_time', modifiedTime);
      updateMetaTag('article:author', author);
    }

    // Structured Data (Schema.org)
    if (schema) {
      let schemaScript = document.getElementById('schema-org');
      if (!schemaScript) {
        schemaScript = document.createElement('script');
        schemaScript.id = 'schema-org';
        schemaScript.type = 'application/ld+json';
        document.head.appendChild(schemaScript);
      }
      schemaScript.textContent = JSON.stringify(schema);
    }

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url || window.location.href);

  }, [title, description, keywords, author, publishedTime, modifiedTime, article, image, url, type, schema]);

  return null;
};

export default SEOHead;
